import styles from "../../pages/contact-us/contact-us.module.css";
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
const redrightarrow = "../../assets/images/contact/redrightarrow.png";
import dynamic from 'next/dynamic';
const Image = dynamic(() => import("next/image"));
const Link = dynamic(() => import("next/link"));

const BranchDelhiAddress = () => {   

  const contactcontent = [
    { heading: "Delhi", Image: pin, address: "No.25,2nd floor pusa road,karol Bagh", address1: "Delhi-110005.", Image1: call, mobileno: "88991 80180", Image2: mail, mailid: "delhi@shankarias.in", direction: "Get Directions", Image3: redrightarrow, url: "https://goo.gl/maps/Tf5Ji7ywXKf9Jg3A7", url1: "https://goo.gl/maps/Tf5Ji7ywXKf9Jg3A7" },
    
    { heading: "Shankar IAS Academy - Head Office", Image: pin, address: (<><div> Door No 18, Old plot No 109, New plot No 259,</div> <div>AL Block, 4th Avenue, Shanthi Colony,</div> <div>Anna Nagar, Chennai-600 040.</div> </>), Image1: call, mobileno1: "9003190030", Image2: mail, mailid: "enquiry@shankarias.in", direction: "Get Directions", Image3: redrightarrow,
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en"
      }, 
      { heading: "TNPSC/Banking/SSC Class  Building", Image: pin, address:(<><div>TNPSC - Block ( Manasarovar ),</div> <div>No. 255 , AL Block , 4th Avenue,</div> <div> Shanthi colony, Anna Nagar,</div> <div> Chennai - 600 040.</div> </>), Image1: call, mobileno: "044-43533445", mobileno1: "044-45543082 | 7667766266  ", Image2: mail, mailid: "enquiry@shankarias.in", direction: "Get Directions", Image3: redrightarrow,
    url: "#",
    url1: "#" },
    
    
  ]


  return (
    <>

    <section id="tnpsccentres">
      <div className="container-fluid" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
        <div className="row">
          <div className="col py-5 px-0">

            <div className="container">
              <div className="row">
                <div className="col">
                  <h2 className={`${styles.sectiontitle}`}>Our Branches</h2>
                </div>
              </div>
            </div>

            <div className="container pt-3">
              <div className="row">

                <div className="col">
                  <div className="row">

                    {contactcontent.map((item, index) => (
                      <div className="col-md-6 col-lg-4 col-12 mb-3" key={index}>
                        <div className={`${styles.contactbox} h-100`}>
                          <div className={`${styles.contactboxheight} px-4 pt-4  pt-md-5`}>


                            <div className={`${styles.acheivername} mb-3`} style={{color:"#db1b0d"}}>{item.heading}</div>

                            <div className="row">
                              <div className="col-1 pe-0">
                                <Image src={item.Image} className="img-fluid" width={14} height={14} alt="location" title="Branch Address" />
                              </div>
                              <div className="col-11 ">
                                <div className={`${styles.acheiverrank} mb-0`}>{item.address}</div>
                                <div className={`${styles.acheiverrank} mb-0`}>{item.address1}</div>
                                <div className={`${styles.contactsubcontent}`}>{item.address2}</div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-1 pe-0">
                                <Image src={item.Image1} className="img-fluid" width={14} height={14} alt="number icon" title="Branch Contact Number" />
                              </div>
                              <div className="col-11 ">
                                <p className={`${styles.acheiverrank} mb-0`}>{item.annanager}<a href="tel:044-66024500" className={`${styles.mobilemaillinks}`}>{item.mobileno}</a></p>
                                <p className={`${styles.acheiverrank}`}>{item.adyar}<a href="tel:76677 66266" className={`${styles.mobilemaillinks}`}>{item.mobileno1}</a></p>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-1 pe-0">
                                <Image src={item.Image2} className="img-fluid" width={14} height={14} alt="email icon" title="Branch Email Address" />
                              </div>
                              <div className="col-11 ">
                                <p className={`${styles.acheiverrank} mb-0`}><a href="mailto:enquiry@shankarias.in" className={`${styles.mobilemaillinks}`}>{item.mailid}</a></p>
                              </div>
                            </div>


                          </div>
                          <hr className="mb-0" />
                          <div className="px-4 pb-1 py-md-2">

                            <div className="row">
                              <div className="col-9 col-xl-10 align-self-center">
                                <Link href={item.url} target={"_blank"} className={`${styles.redunderline} mb-0`}>{item.direction}</Link>
                              </div>
                              <div className="col-3 col-xl-2">
                                <Link href={item.url1} target={"_blank"}><Image src={item.Image3} width={100} height={100} className={`${styles.img} img-fluid `} alt="arrow" title="Link" /></Link>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    ))}


                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default BranchDelhiAddress